import { render, staticRenderFns } from "./PageResetPassword.vue?vue&type=template&id=d6eccc3e"
import script from "./PageResetPassword.vue?vue&type=script&lang=js"
export * from "./PageResetPassword.vue?vue&type=script&lang=js"
import style0 from "./PageResetPassword.vue?vue&type=style&index=0&id=d6eccc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports